import { gql } from '@apollo/client';

export const GET_CATEGORIES = gql`
  query querySupportCategories {
    querySupportCategories {
      category
      label
    }
  }
`;

export const GET_SUPPORTS = gql`
  query querySupportListByCategory($input: SupportListByCategoryInput!) {
    querySupportListByCategory(input: $input) {
      list {
        id
        title
        content: contents
      }
      page {
        pageNumber
        totalElements
      }
    }
  }
`;
